import { Grid } from "@mui/material";
import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";
import DynamicTabsDrawer from "../../../components/DynamicTabDrawer";
import NavigationDrawer from "../../../components/NavigationDrawer/index";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import Profile from "./Profile";

const tabs = [{ label: "personalDetails", value: "personal" }];

function SupplierSettings() {
  const dispatch = useDispatch();
  // Redux states
  const activeTab = useSelector((state) => state.activeTab.tabs);

  // Function

  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, admin_setting: tab }));
  };

  return (
    <NavigationDrawer>
      <Grid container spacing={1}>
        <Grid item xs={12} md={2.3}>
          <DynamicTabsDrawer
            primaryHeading={t("team")}
            tabs={tabs}
            activeTab={"personal"}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.7}>
          <Profile />
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
}

export default SupplierSettings;
